module.exports = __webpack_public_path__ + "static/media/nervos-black.ee61bbf2.svg";


//////////////////
// WEBPACK FOOTER
// ./public/nervos-black.svg
// module id = 16
// module chunks = 0